import {observable, action, runInAction, computed} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {message} from "antd/lib/index";
import {isAuthenticated} from "../../../../utils/Session";
import {setStore} from "../../../../utils/Utils";
import uuid from "uuid/v4";

class CMSNewsStore {
    @observable list
    @observable pagination
    @observable loading
    @observable modal
    @observable forms
    @observable search
    @observable initModul
    @observable cmsCategory
    @observable defaultContentKey
    @observable fileList
    @observable pdfName
    @observable pdfUrl
    @observable pdfList
    @observable pdfContent

    constructor() {
        this.list = []
        this.pagination = {}
        this.loading = false
        this.modal = 'hide'
        this.forms = {}
        this.search = {}
        this.initModul = false
        this.cmsCategory = []
        this.defaultContentKey = '文本格式'
        this.fileList = []
        this.pdfName = ''
        this.pdfUrl = ''
        this.pdfList = []
        this.pdfContent = {}
    }


    /**调用setStore方法并传入当前this**/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 新闻列表 + 标题查询
     * 分页
     */
    @action
    initListNews = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search = {}
        Object.keys(this.search).forEach(key => {
            search[`search.${key}`] = this.search[key] ? this.search[key] : ''
        })
        search.page = page
        search.size = 10
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/newsAndCategory`,search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    title:item.title,
                    categoryId:item.categoryId,
                    createTime: item.createTime,
                }
            })
            this.pagination = {
                total: res.totalElements,
                results: res.size,
                page: res.number + 1,
            }
            this.loading = false
        })
    }

    /**
     * 显示模式
     */
    @action showModal = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modal = flag ? 'show' : 'hide'
            this.pdfName=''
            this.pdfUrl=''
            this.fileList=[]
            this.loading = false
        })
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }

    @action setFormsContents = (content) => {
        runInAction(() => {
                this.forms.content = content
            }
        )
    }

    /**
     * 初始化新闻栏目下拉框
     * @returns {Promise.<void>}
     */
    @action initeCategory = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/category/list?search.state=1&&size=100`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.cmsCategory = res.content
            this.loading = false
        })
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.forms.id},
            title: {value: this.forms.title},
            categoryId:{value:this.forms.categoryId},
            content:{value:this.forms.content},
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action.bound
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            title: fields.title.value,
            categoryId:fields.categoryId.value,
            content:fields.content.value,
        }
        this.forms = forms
    }

    /**
     * 新增新闻 + 修改新闻
     */
    @action saveNews = async () => {
        if((this.forms.content&&this.forms.content!==' ')||(this.pdfUrl&&this.pdfUrl!==' ')){
            runInAction(() => {
                this.loading = true
            })
            let id = uuid()
            if (!this.forms.id) {
                const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/news/add`, {
                    ...this.forms,
                    id:id,
                    pdfName:this.pdfName,
                    pdfUrl:this.pdfUrl,
                    content:this.forms.content?this.forms.content:' '
                })
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('保存新闻成功')
                    this.forms = {}
                    this.defaultContentKey = '文本格式'
                    this.fileList=[]
                    this.loading = false
                    this.fileList.length>0&&this.saveEnclosure(id)
                    this.initListNews(this.page)
                })

            }else {
                const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/news/update`, {
                    ...this.forms,
                    pdfName:this.pdfName,
                    pdfUrl:this.pdfUrl,
                    content:this.forms.content?this.forms.content:' '
                })
                if (res && res.status >= 400) {
                    message.error('修改新增失败')
                    return
                } else {
                    runInAction(() => {
                        this.modal = 'hide'
                        message.success('修改新闻成功')
                        this.forms = {}
                        this.defaultContentKey = '文本格式'
                        this.fileList=[]
                        this.loading = false
                    })
                    this.initListNews(this.page)
                }
            }
        }else {
            message.warning(`请填写内容或上传pdf!`)
        }
    }

    /**
     * 上传附件
     * @returns {Promise<void>}
     */
    @action
    saveEnclosure=async (id)=>{
        let list = []
        this.fileList.map(item=>{
            list.push({
                otherId:id,
                url:item.response,
                name:item.name
            })
        })
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/publicAccessories/add`,list)
    }

    /**
     * 清空forms
     */
    @action empetyForms = () => {
        runInAction(() => {
                this.forms = {}
                if (window.tinymce.activeEditor) {
                    window.tinymce.activeEditor.setContent('')
                }
            }
        )
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        if (!id) {
            runInAction(() => {
                this.forms = {}
                this.loading = false
                this.modal = 'show'
            })
        } else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/news/id/${id}`)
            if (res && res.status === 0) {
                return
            }
            if (this.initModul && window.tinymce.activeEditor) {
                window.tinymce.activeEditor.setContent(res.content)
            } else {
                runInAction(() => {
                    this.initModul = true
                })
            }
            runInAction(() => {
                if(res.pdfUrl){
                    this.defaultContentKey='PDF'
                }else {
                    this.defaultContentKey='文本格式'
                }
                this.forms = res
                this.pdfName=res.pdfName
                this.pdfUrl=res.pdfUrl
                this.pdfContent=res
                let list = []
                res.annex.map(item=>list.push({
                    name:item.name,
                    // url:item.url,
                    uid:uuid(),
                }))
                this.fileList=list
                this.loading = false
                this.modal = 'show'
            })
        }
    }

    /**
     * 删除
     */
    @action
    deleteNewsId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/news/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.list.length === 1){
            await this.initListNews(this.pagination.page -1)
        }else{
            await this.initListNews(this.pagination.page)
        }
    }

    /**
     * 每次更新search框时，回写数据
     * @param values search数据
     */
    @action
    onSearchFieldChange(values) {
        runInAction(() => {
            this.search = values
        })
    }
}
export default new CMSNewsStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/CMS/CMSNews/store.js